  /* eslint-disable react-hooks/exhaustive-deps */

"use client";
import dynamic from 'next/dynamic';

import React, { useState, Fragment, useEffect } from "react";
const Button = dynamic(() => import('@/components/ui/Button'));
import { Icon } from "@iconify/react/dist/iconify.js";
import { useAuth } from "@/contexts/authContext";
// import { supabase } from "@/supabase/client";
import LauncherTeaserModal from "./launcher-teaser-modal";

const Launcher = ({ launcher }) => {
  const { isAuthenticated, isFetchingUser, user, ipAddress } = useAuth();
    const [launcherStatus, setLauncherStatus] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);

    useEffect(() => {
        if (launcher !== null && isAuthenticated && !isFetchingUser && user) {
            // Check if launcher status is "installed"
            if (launcher.status === 'installed') {
                setLauncherStatus(true);
            } else {
                setLauncherStatus(false);
            }
        } else {
            setLauncherStatus(false);
        }
    }, [launcher, isAuthenticated, isFetchingUser, user]);

    // COMMENTED OUT: Original download functionality
    // const handleDownload = async (e) => {
    //     e.preventDefault();
        
    //     if (user && isAuthenticated) {
    //         try {
    //             const userUid = user.user_id || user.uid;
                
    //             // Check if user exists in the launcher table
    //             const { data: existingUser, error: fetchError } = await supabase
    //                 .from('mxs_play_launcher_user')
    //                 .select('*')
    //                 .eq('uid', userUid)
    //                 .maybeSingle();

    //             if (fetchError) {
    //                 console.error('Error checking user existence:', fetchError);
    //                 return; // Exit early if there's an error
    //             }

    //             const currentDateTime = new Date().toISOString();

    //             if (!existingUser) {
    //                 // Create new entry
    //                 const { error: insertError } = await supabase
    //                     .from('mxs_play_launcher_user')
    //                     .insert({
    //                         uid: userUid,
    //                         downloaded_at: currentDateTime,
    //                         status: 'downloaded',
    //                         launcher_version: '1.0.0', // You can modify this based on your needs
    //                         public_ip: ipAddress
    //                     });

    //                 if (insertError) {
    //                     console.error('Error creating launcher user entry:', insertError);
    //                 }
    //             } else {
    //                 // Update existing entry with new download time
    //                 const { error: updateError } = await supabase
    //                     .from('mxs_play_launcher_user')
    //                     .update({
    //                         downloaded_at: currentDateTime,
    //                         updated_at: currentDateTime,
    //                         public_ip: ipAddress
    //                     })
    //                     .eq('uid', userUid);

    //                 if (updateError) {
    //                     console.error('Error updating launcher user entry:', updateError);
    //                 }
    //             }
    //         } catch (error) {
    //             console.error('Error handling download tracking:', error);
    //         }
    //     }
        
    //     // Proceed with the download
    //     window.location.href = "https://mxsgames.s3.eu-north-1.amazonaws.com/launcher/MetaXseed+Launcher+Setup.exe";
    // };

    // COMMENTED OUT: Original launch functionality
    // const handleLaunch = async (e) => {
    //     e.preventDefault();
        
    //     // Set up a flag to track if we're still on the page after trying to launch
    //     let launchFailed = false;
        
    //     // Set a timeout to check if we're still on the page
    //     // If we are, the launcher probably failed to open
    //     const timeout = setTimeout(async () => {
    //         launchFailed = true;
    //         console.log('Launcher failed to open or user declined the prompt');
    //         await handleLauncherNotFound();
    //     }, 3000); // 3 seconds should be enough time for the launcher to open
        
    //     try {
    //         // Add event listener to detect if page visibility changes
    //         // If page is hidden, the launcher might have opened
    //         const handleVisibilityChange = () => {
    //             if (document.hidden) {
    //                 // Page is hidden, launcher probably opened
    //                 clearTimeout(timeout);
    //                 document.removeEventListener('visibilitychange', handleVisibilityChange);
    //             }
    //         };
            
    //         document.addEventListener('visibilitychange', handleVisibilityChange);
            
    //         // Try to launch the launcher
    //         window.location.href = "mxsplay://launch";
            
    //         // Add a cleanup function for the event listener
    //         // This will run if the user comes back to the browser
    //         setTimeout(() => {
    //             document.removeEventListener('visibilitychange', handleVisibilityChange);
    //         }, 5000);
            
    //     } catch (error) {
    //         clearTimeout(timeout);
    //         console.error('Failed to launch:', error);
    //         // If launch fails with an error, definitely mark as uninstalled
    //         await handleLauncherNotFound();
    //     }
    // };

    // COMMENTED OUT: Original launcher not found handler
    // const handleLauncherNotFound = async () => {
    //     if (user && isAuthenticated) {
    //         try {
    //             const userUid = user.user_id || user.uid;
    //             const currentDateTime = new Date().toISOString();

    //             // Mark as potentially uninstalled
    //             await supabase
    //                 .from('mxs_play_launcher_user')
    //                 .update({
    //                     status: 'uninstalled',
    //                     uninstalled_at: currentDateTime,
    //                     updated_at: currentDateTime
    //                 })
    //                 .eq('uid', userUid);

    //             // Refresh launcher status
    //             setLauncherStatus(false);
    //         } catch (error) {
    //             console.error('Error updating launcher status:', error);
    //         }
    //     }
    // };

    // NEW: Teaser functionality for development version
    const handleLauncherTeaser = (e) => {
        e.preventDefault();
        setIsModalOpen(true);
        // console.log("Launcher teaser clicked - New version under development");
    };

    return (
        <Fragment>
            {/* Always show MXS Play download button for now - Launch button commented out */}
            {/* {!launcherStatus ? ( */}
                <div style={{ display: "flex", gap: 12 }}>
                    <Button
                          className="shadow-sm focus:outline-none !ring-0 !ring-transparent !ring-offset-0 outline-none hover:outline-none btn-dark border-2 border-metaxseed-gray text-white text-xs lg:text-sm gothamMedium rounded-full px-2 py-1 sm:px-3 sm:py-2 flex items-center justify-center"
                        onClick={handleLauncherTeaser}>
                        <div className="flex items-center font-normal">
                            <Icon icon="line-md:download-loop" style={{ fontSize: "24px" }} /> <span className="hidden lg:block ml-1"> MXS Play</span>
                        </div>
                    </Button>
                </div>
            {/* ) : (
                <div style={{ display: "flex", gap: 12 }}>
                    <Button
                        className="shadow-lg focus:outline-none ring-0 ring-transparent ring-offset-0 outline-none hover:outline-none bg-green-800 font-normal border-2 border-metaxseed-gray text-white text-xs lg:text-sm gothamMedium rounded-full sm:pl-6 sm:pr-7 pl-3 pr-4 py-3"
                        onClick={handleLauncherTeaser}>
                        <div className="flex items-center font-normal">
                            <Icon icon="ion:rocket" style={{ fontSize: "24px" }} /> <span className="hidden lg:block ml-2"> Launch</span>
                        </div>
                    </Button>
                </div>
            )} */}
            
            {/* Launcher Teaser Modal */}
            <LauncherTeaserModal 
                isOpen={isModalOpen} 
                onClose={() => setIsModalOpen(false)} 
            />
        </Fragment>
    );
};

export default Launcher;
